import RestClient from './../../service/rest-client';
import {Signal} from 'signals';

class Service {
    event = {
        onDashboardMetrics: new Signal(),
        onDashboardInfo: new Signal(),
    };

    // metrics
    fetchDashboardMetrics() {
        var self = this;
        RestClient.isSessionActive();

        var urlRequestEndPointString = "/reporting/dashboard/metrics";
        var urlRequestTemplate = urlRequestEndPointString;

        return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
            self.parseResultData(data.results);
            this.event.onDashboardMetrics.dispatch(data);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseResultData(resultData) {
        var self = this;

        resultData.forEach(function(dataItem) {
            if (dataItem.id == 2 || dataItem.id == 3 || dataItem.id == 4) {
                dataItem.totalLastWeek = dataItem.totalLastWeek + " " + "(new: " + dataItem.newLastWeek + " repeat: " + dataItem.repeatLastWeek + ")";
                dataItem.totalLastMonth = dataItem.totalLastMonth + " " + "(new: " + dataItem.newLastMonth + " repeat: " + dataItem.repeatLastMonth + ")";
            }
        });
    }
    // end metrics

    // info
    fetchDashboardInfo() {
        var self = this;
        RestClient.isSessionActive();

        var urlRequestEndPointString = "/reporting/dashboard/info";
        var urlRequestTemplate = urlRequestEndPointString;

        return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
            this.event.onDashboardInfo.dispatch(data);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }
} export default new Service();